module.exports = __webpack_public_path__ + "static/media/2.20d57601.jpg";